/* eslint-disable eqeqeq */

import { convertToObjectKeyString, TranslateString } from "Utils/Common";
import './LoanOfferComparison.scss';
import { PaymentMethodOptions, ReferenceRateBaseOptions } from "constants/Constants";
import 'moment/locale/fi';


const LoanOfferComparisonOtherTerms = (props:any) => {
    const allBanks = props?.allBanks;
    return (
        <>
            <tr className='text-left border-white cu-bg-subgreen' key={Math.random()}>
                <th></th>
                <th className={`border-0`}>
                    {TranslateString("Other terms") }
                </th>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <th className='text-left border-0' key={index+Math.random()}> 
                            {element?.BANK_DATA?.bank_name} 
                        </th>;
                    })
                }
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="fw-bold">{TranslateString("Interest rate terms")}</td>
                <td className="p-0 border bg-white">{""}</td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white p-0' key={index+Math.random()}>
                            {element?.interest_rate_terms || "0 % + marginaali"}
                        </td>;
                    })
                }
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="fw-bold">{TranslateString("Shareholder repayments")}</td>
                <td className="p-0 border bg-white"></td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white p-0' key={index+Math.random()}>
                            {element?.shareholder_repayments || element?.BANK_DATA?.shareholder_repayments || '-'}
                        </td>;
                    })
                }
            </tr>
            <tr className='text-left border-white' key={Math.random()}>
                <th colSpan={allBanks?.length+2}>&nbsp;</th>
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="fw-bold p-0">
                    <div>{TranslateString("Optional annual repayments")}</div>
                    {/* <div className="border w-100">&nbsp;</div>
                    <div className="border w-100">&nbsp;</div>
                    <div className="border w-100">&nbsp;</div> */}
                </td>
                <td className="text-left border bg-white">&nbsp;</td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white p-0' key={index+Math.random()} >
                            {
                                [
                                    { value: 12, label: 12 },
                                    { value: 4, label: 4 },
                                    { value: 2, label: 2 },
                                    { value: 1, label: 1 },
                                    { value: "muu", label: TranslateString("Other") },
                                ]?.map((element2:any)=>{
                                    if((element?.opt_annual_repayments ? element?.opt_annual_repayments?.split(","):[]).find((f:any)=>f?.toString()===element2?.value?.toString())){
                                        return <div>
                                            <p className={`btn-2 my-0`}>{element2?.label}</p>
                                            <p className="p-1 my-0 py-0">
                                                { (element?.opt_annual_repayments?.split(",")?.filter((f:any)=>(f==="muu"))?.length===1) ? element?.opt_annual_repayments_other :"" }
                                            </p>
                                        </div>
                                    }else{
                                        return null;
                                    }
                                })?.filter((f:any)=>f!==null)
                            }
                        </td>;
                    })
                }
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="fw-bold p-0">
                    <div>{TranslateString("Optional repayment method")}</div>
                    {/* <div className="border w-100">&nbsp;</div>
                    <div className="border w-100">&nbsp;</div> */}
                </td>
                <td className="text-left border bg-white">&nbsp;</td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white p-0' key={index+Math.random()}>
                            {
                                PaymentMethodOptions?.map((element2:any)=>{
                                    if((element?.opt_repayment_method?.length ? element?.opt_repayment_method?.split(','):(element?.offer_payment_method?.length ? element?.offer_payment_method : [])).find((f:any)=>f?.toString()===element2?.value?.toString())){
                                        return <div><small className={`btn-2`}>{element2?.label}</small></div>
                                    }else{
                                        return null;
                                    }
                                })?.filter((f:any)=>f!==null)
                            }
                        </td>;
                    })
                }
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="fw-bold">
                    <div>{TranslateString("Viitekoron vaihtoehto")}</div>
                    {/* <div className="border w-100">&nbsp;</div>
                    <div className="border w-100">&nbsp;</div> */}
                </td>
                <td className="text-left border bg-white p-0"></td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white p-0' key={index+Math.random()}>
                            {
                                (element?.opt_reference_rate?.length ? element?.opt_reference_rate?.split(','):(element?.offer_ref_rate_base_other_term?.length ? element?.offer_ref_rate_base_other_term : []))?.map((e:any)=>{
                                    return <div><small className={`btn-2`}>{e}</small></div>
                                })
                            }
                        </td>;
                    })
                }
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="fw-bold p-0">{TranslateString("Payment transaction transfer")}</td>
                <td className="text-left border bg-white">&nbsp;</td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white p-0 word-break-all' key={index+Math.random()}>
                            <span>{(element?.offer_transfer_payment == "1") ? TranslateString("true") : (element?.offer_transfer_payment == 0 ? TranslateString("false") : '-')}</span><br/>
                            {element?.pay_transaction_transfer}
                        </td>;
                    })
                }
            </tr>
            <tr className='text-left cu-table-row2' key={Math.random()}>
                <td className="cu-min-height-100 fw-bold">{TranslateString("Other terms")}</td>
                <td className="text-left border bg-white">&nbsp;</td>
                {
                    allBanks?.map((element:any,index:any)=>{
                        return <td className='text-left border bg-white cu-min-height-100 p-0 word-break-all' key={index+Math.random()}>
                            {element?.other_terms}
                        </td>;
                    })
                }
            </tr>
            <tr>
                {/* <th colSpan={allBanks?.length+2}>&nbsp;</th> */}
            </tr>
        </>
    );
};
export default LoanOfferComparisonOtherTerms;